import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#212121';
const whiteColor = '#FFFFFF';
const primaryBlueColor = '#191970';
const grey500Color = '#979797';
const grey300Color = '#BFBFBF';

const dpmoLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#D50000',
    info: '#2196F3',
    primary: primaryBlueColor,
    secondary: whiteColor,
    success: '#388E3C',
    warning: '#FB8C00',
    background: grey300Color,
    'on-surface': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: primaryBlueColor,
    systemToolbar: primaryBlueColor,
    navigationDrawer: primaryBlueColor,
    neutral: grey500Color,
    'neutral-light': whiteColor,
    'neutral-border': grey300Color,
    'on-navigationDrawer': '#4A4A4A',
    'on-systemToolbar': whiteColor,
  },
};

export const dpmoTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: dpmoLightTheme,
  },
};
